// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1HmLb","fileDisabled":"File_fileDisabled__kT-aE"};